//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { SidebarContext } from "../../../context/SidebarContext"



//--------------- EXPORTAÇÃO DO COMPONENTE MAIN ---------------//
export default function Main() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { isOpen } = useContext(SidebarContext); // Contexto que armazena se a Sidebar está ou não aberta



    //--------------- RETORNO DO COMPONENTE MAIN ---------------//
    return (
        <>

            {/* DIV BACKGROUND */}
            <div className={`transition-all duration-300 min-h-screen bg-surface-1 text-white flex items-center justify-center text-[10vh] ${isOpen ? 'lg:ml-64' : 'sm:ml-16'}`}>

                {/* SÍMBOLO DE LOADING */}
                <i class="fas fa-circle-notch fa-spin opacity-70"></i>

            </div>

        </>
    )
}